export default {
    primary: {
        main: "#4caf50",
        light: "#66bb6a",
        contrastText: "#fff"
    }
}